import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";
import { PagedCrudService } from "@features/grid";
import { IRavenCategory } from "./models/raven-category";


@Injectable({
    providedIn: "root"
})
export class RavenCategoryService extends PagedCrudService<IRavenCategory> {
    public readonly url = "api/raven-category";
    public readonly entityTitle = "RavenCategory";


    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }

    getAllCategories(): Promise<IRavenCategory[]> {
        return this.handleRequest<IRavenCategory[]>(
            this.http.get<IRavenCategory[]>(`${this.url}/all-categories`),
            this.handlersFactory.getForReadAll());
    }
}